<template>
  <Dashboard title="Components">
    <div id="components">
      <h3 class="components--title">{{title}}</h3>

      <Button
        class="components--add-button"
        title="Add component"
        to=""
        active=true
        showAddIcon=true
        v-on:handleClick="handleModal()"
      />

      <div class="content">
        <div class="list">
          <transition-group
            name="flip-list"
            tag="div"
          >
            <li 
              @dragover="(e) => onDragOver(item, index, e)" 
              @dragend="(e) => finishDrag(item, index, e)"
              @dragstart="(e) => startDrag(item, index, e)"
              v-for="(item, index) in components"
              class="item"
              :class="{
                over: (item === over.item && item !== dragFrom),
                [over.dir]: (item === over.item && item !== dragFrom)
              }"
              draggable="true"
              v-bind:key="index"
            >
              <ComponentBlock
                :data="item"
                v-on:handleDeleteClick="handleComponentDelete(
                  index,
                  item.id
                )"
              />
            </li>
          </transition-group>

          <Loading 
            v-if="isLoading"
            full="true"
          />

          <Background v-if="components.length === 0 && isLoading === false">
            <p class="table--no-items">
              No components found
            </p>
          </Background>
        </div>
      </div>
    </div>

    <Modal 
      closeIcon="true"
      v-on:close="handleModal"
      v-if="!modal.isHidden"
    >      
      <template v-slot:title>
        <h3>Add Component</h3>
      </template>

      <template v-slot:content>
        <form>
          <div class="row">
            <Input
              class="col-24"
              placeholder="Title"
              type="text"
              :value="modal.fields.title"
              v-model="modal.fields.title"
            />

            <div class="col-24 input">
              <p>Type</p>

              <div class="row">
                <div class="col-12 col-24-sm">
                  <RadioInput
                    placeholder="Page"
                    name="radio"
                    :checked="true"
                    v-on:handleClick="handleRadioInput('PageComponent')"
                  />

                  <RadioInput
                    placeholder="Answer display"
                    name="radio"
                    :checked="false"
                    v-on:handleClick="handleRadioInput('AnswerDisplayComponent')"
                  />

                  <RadioInput
                    placeholder="Checkbox"
                    name="radio"
                    :checked="false"
                    v-on:handleClick="handleRadioInput('CheckboxComponent')"
                  />

                  <RadioInput
                    placeholder="Drag and drop"
                    name="radio"
                    :checked="false"
                    v-on:handleClick="handleRadioInput('DragAndDropComponent')"
                  />

                  <RadioInput
                    placeholder="Feedback"
                    name="radio"
                    :checked="false"
                    v-on:handleClick="handleRadioInput('FeedbackComponent')"
                  />

                  <RadioInput
                    placeholder="Radio"
                    name="radio"
                    :checked="false"
                    v-on:handleClick="handleRadioInput('RadioComponent')"
                  />
                </div>

                <div class="col-12 col-24-sm">
                  <RadioInput
                    placeholder="Slider"
                    name="radio"
                    :checked="false"
                    v-on:handleClick="handleRadioInput('SliderComponent')"
                  />

                  <RadioInput
                    placeholder="Textarea"
                    name="radio"
                    :checked="false"
                    v-on:handleClick="handleRadioInput('TextareaComponent')"
                  />

                  <RadioInput
                    placeholder="Textfield"
                    name="radio"
                    :checked="false"
                    v-on:handleClick="handleRadioInput('TextFieldComponent')"
                  />

                  <RadioInput
                    placeholder="Wordgrid"
                    name="radio"
                    :checked="false"
                    v-on:handleClick="handleRadioInput('WordgridComponent')"
                  />

                  <RadioInput
                    placeholder="Test"
                    name="radio"
                    :checked="false"
                    v-on:handleClick="handleRadioInput('TestComponent')"
                  />
                </div>
              </div>
            </div>
          </div>

          <ButtonForm
            title="Save component"
            v-on:handleClick="handleModalButton()"
          />
        </form>
      </template>      
    </Modal>
  </Dashboard>  
</template>

<script>
  import { API } from '../../../../services/api.ts'
  import Dashboard from '../../../../components/dashboard/dashboard.vue'
  import Button from '../../../../components/buttons/button.vue'
  import ComponentBlock from '../../../../components/componentBlock/componentBlock.vue'
  import Loading from '../../../../components/loading/loading.vue'
  import Background from '../../../../components/background/background.vue'
  import Modal from '../../../../components/modal/modal.vue'
  import Input from '../../../../components/form/input.vue'
  import RadioInput from '../../../../components/form/radio.vue'
  import ButtonForm from '../../../../components/form/button.vue'

  export default {
    name: 'Components',
    components: {
      Dashboard,
      Button,      
      ComponentBlock,
      Loading,
      Background,
      Modal,
      Input,
      RadioInput,
      ButtonForm
    },
    data() {
      return {
        title: '',
        isLoading: true,
        components: [],
        over: {},
        startLoc: 0,
        dragging: false,
        dragFrom: {},
        modal: {
          isHidden: true,
          fields: {
            title: '',
            component: 'PageComponent',
            rank: 0
          }
        }
      }
    },
    methods: {
      startDrag(item, i, e) {
        this.startLoc = e.clientY;
        this.dragging = true;
        this.dragFrom = item;
      },
      finishDrag(item, pos) {
        this.components.splice(pos, 1)
        this.components.splice(this.over.pos, 0, item);
        this.over = {}

        for (const [index, item] of this.components.entries()) {
          item.rank = index + 1;

          API.patch(
            `index.cfm?act=lessonpageblocks.item&id=${item.id}`,
            {
              rank: `${index + 1}`
            }
          ).then(
            response => {
              console.log(response.data.data);
            }
          )
        }
      },
      onDragOver(item, pos, e) {
        const dir = (this.startLoc < e.clientY) ? 'down': 'up';
        setTimeout(() => {
          this.over = { item, pos, dir };        
        }, 10)
      },
      handleRadioInput: function(componentName) {
        this.modal.fields.component = componentName;
      },
      handleModal: function() {
        if (this.modal.isHidden === true) {
          this.modal.isHidden = false;
        } else {
          this.modal.isHidden = true;
        }
      },
      handleModalButton: function() {
        this.$el.querySelector('form').reportValidity();

        let createObject = {};

        if (this.modal.fields.component === 'TestComponent') {
          createObject = {
            title: this.modal.fields.title,
            component: this.modal.fields.component,
            rank: this.components.length + 1,
            questiondef: {
              choices: [],
              feedback: {
                negative: '',
                positive: ''
              }
            }
          }
        } else {
          createObject = {
            title: this.modal.fields.title,
            component: this.modal.fields.component,
            rank: this.components.length + 1
          }
        }

        API.post(
          `index.cfm?act=lessonpageblocks.item&lessonpageid=${this.$route.params.id}`,
          createObject
        ).then(
          response => {
            console.log(response);
            location.reload();
          }
        )
      },
      handleComponentDelete: function(
        index,
        id
      ) {
        if (confirm("Are you sure you want to delete this component?")) {
          this.components.splice(index, 1);

          API.delete(
            `index.cfm?act=lessonpageblocks.item&id=${id}`
          ).then(
            response => {
              console.log(response);
            }
          )
        }
      }
    },
    mounted() {
      const self = this;

      API.get(
        `index.cfm?act=lessonpageblocks.list&id=${this.$route.params.id}`
      ).then(
        response => {
          console.log(response.data.data);
          this.components = response.data.data;
          this.isLoading = false;
        }
      ).catch(function (error) {
        if (error.response.status === 403) {
          localStorage.removeItem('selectedApplicationName');
          localStorage.removeItem('selectedApplicationId');        
          self.selectedApplicationId = null
        }
      });
    }
  }
</script>

<style lang="scss">
  #components {
    
    .components--title {
      float: left;
      font-size: 18px;
    }

    .components--add-button {
      float: right;
    }

    .content {
      float: left;
      width: 100%;
    }
  }

  .list > div {
    display: flex;
    flex-direction: column; 

    &:first-child {
      margin-top: 15px;
    }

    .item {
      display: inline-block;

      &:hover {
        cursor: move;
        cursor: grab;
      }
    }

    .flip-list-move {
      transition: transform .2s;
    }

    .over {
      opacity: .6;
    }
  }
</style>
